import styled from 'styled-components';

export const NameCellContainer = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black9};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
`;
